import { useTranslation } from 'react-i18next';

import { useAddToast } from '@/components/Snackbar/Snackbar';

export const useCopyToClipboard = (displayToast = true) => {
	const addToast = useAddToast();
	const { t } = useTranslation();

	const copyToClipboard = async (text: string) => {
		try {
			await navigator.clipboard.writeText(text);
			if (displayToast) {
				addToast(
					t('Successfully copied to the clipboard'),
					undefined,
					'success'
				);
			}
			return true;
		} catch {
			return false;
		}
	};

	return { copyToClipboard };
};
